import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["hidden", "required", "disabled", "autocomplete"]
const _hoisted_2 = ["selected"]
const _hoisted_3 = ["selected", "value"]
const _hoisted_4 = { class: "invalid-feedback order-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("select", {
      class: _normalizeClass(["form-select", _ctx.validate()]),
      "aria-label": "Default select example",
      hidden: (_ctx.getValue(_ctx.statTypeEnum.ElementType) === 'hidden'),
      required: _ctx.attributeCheck(_ctx.statTypeEnum.Required),
      disabled: _ctx.attributeCheck(_ctx.statTypeEnum.Disabled),
      autocomplete: _ctx.returnIfExists(_ctx.statTypeEnum.AutoComplete),
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.regionType.RegionTypes[_ctx.object.Region].ObjectTypes[_ctx.object.ObjectEnum].ChooseSubType(_ctx.object as ObjectTemplate, $event.target.value)))
    }, [
      _createElementVNode("option", {
        value: "",
        selected: _ctx.object.Stats[_ctx.statTypeEnum.Value] === undefined,
        hidden: ""
      }, "Select a type.", 8, _hoisted_2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.object.Stats[_ctx.statTypeEnum.ItemList].Data), (item, key, index) => {
        return (_openBlock(), _createElementBlock("option", {
          selected: _ctx.check(item.id),
          key: `${ key }-${ index }`,
          value: item.id
        }, _toDisplayString(item.name), 9, _hoisted_3))
      }), 128))
    ], 42, _hoisted_1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.returnIfExists(_ctx.statTypeEnum.ErrorMessage)), 1)
  ], 64))
}